import Tooltip from '@paradigm/design-system/src/components/Tooltip';

const QuantityInputTooltip = () => (
  <div css="display: flex; align-items: center;">
    Quantity
    <Tooltip
      id="qty-input"
      css="margin-left:2px"
      tooltipContent={
        <>
          <p>
            Quantity entered is subject to Exchange Min Block Size constraints.
          </p>
          <p>
            Paradigm will attempt to execute the entered quantity from the list
            of available quotes at the corresponding limit price and better.
          </p>
          <p className="m-0">
            Paradigm does not guarantee that the full quantity will be executed.
          </p>
        </>
      }
    />
  </div>
);

export default QuantityInputTooltip;
